export default __webpack_public_path__ + "static/media/PERFIL_MENTOR.88c90685.png";